import {Injectable} from '@angular/core';

@Injectable()
export class DateUtilService {

  diffDateInSeconds(dateOne: Date, dateTwo: Date): number {
    return (dateOne.getTime() - dateTwo.getTime()) / 1000;
  }

  diffDateInDays(dateOne: Date, dateTwo: Date): number {
    return (dateOne.getTime() - dateTwo.getTime()) / (1000 * 3600 * 24);
  }

  formatOptionsTimePicker(date: Date): string {
    return ('0' + (date.getHours())).slice(-2) + ':' + ('0' + (date.getMinutes())).slice(-2) + ':' + ('0' + date.getSeconds()).slice(-2);
  }

  formatDateForStamp(date: Date): string {
    return date.getUTCDate() + '/' + (date.getUTCMonth() + 1) + '/' + date.getUTCFullYear();
  }

  formatDate(date: Date): string {
    return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
  }

  formatDatePicker(date: Date): string {
    return date.getUTCFullYear() + '-' + ('0' + (date.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + date.getUTCDate()).slice(-2);
  }

  formatDateTimeUTC(date: Date): string {
    return date.getUTCFullYear() + '-' + ('0' + (date.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + date.getUTCDate()).slice(-2) + 'T'
      + ('0' + date.getUTCHours()).slice(-2) + ':' + ('0' + date.getUTCMinutes()).slice(-2) + ':00.000Z';
  }

  formatDateTimeNoUTC(date: Date): string {
    return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) + 'T'
      + ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2) + ':00.000Z';
  }

  isSameDayToday(date: Date): boolean {
    const now = new Date();
    return now.getDate() === date.getDate() && now.getMonth() === date.getMonth() && now.getFullYear() === date.getFullYear();
  }

  addMinutes(date, minutes): Date {
    return new Date(date.getTime() + minutes * 60000);
  }

  addHours(date, hours): Date {
    return new Date(date.getTime() + hours * 60 * 60000);
  }

}
